import React from 'react';
interface InnoverseLogoProps {
  size?: number;
  className?: string;
  variant?: 'dark' | 'light';
}
export function InnoverseLogo({
  size = 36,
  className = '',
  variant = 'dark'
}: InnoverseLogoProps) {
  const primary = variant === 'dark' ? '#1e3a8a' : '#93c5fd';
  const secondary = variant === 'dark' ? '#2563eb' : '#bfdbfe';
  const accent = variant === 'dark' ? '#3b82f6' : '#dbeafe';
  const lines = variant === 'dark' ? '#94a3b8' : '#cbd5e1';
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-99">
      {/* Circuit lines radiating outward */}
      {/* Top */}
      <line x1="50" y1="18" x2="50" y2="4" stroke={lines} strokeWidth="1.2" data-id="element-100" />
      <circle cx="50" cy="3" r="2" fill={accent} data-id="element-101" />

      <line x1="38" y1="22" x2="28" y2="6" stroke={lines} strokeWidth="1" data-id="element-102" />
      <circle cx="27" cy="5" r="1.5" fill={lines} data-id="element-103" />

      <line x1="62" y1="22" x2="72" y2="6" stroke={lines} strokeWidth="1" data-id="element-104" />
      <rect x="70.5" y="3.5" width="3" height="3" fill={accent} data-id="element-105" />

      {/* Top-right */}
      <line x1="72" y1="32" x2="88" y2="20" stroke={lines} strokeWidth="1.2" data-id="element-106" />
      <circle cx="89" cy="19" r="2" fill={accent} data-id="element-107" />

      <line x1="76" y1="42" x2="94" y2="36" stroke={lines} strokeWidth="1" data-id="element-108" />
      <circle cx="95" cy="36" r="1.5" fill={lines} data-id="element-109" />

      {/* Right */}
      <line x1="78" y1="50" x2="96" y2="50" stroke={lines} strokeWidth="1.2" data-id="element-110" />
      <rect x="95" y="48" width="3" height="3" fill={accent} data-id="element-111" />

      {/* Bottom-right */}
      <line x1="72" y1="68" x2="88" y2="80" stroke={lines} strokeWidth="1.2" data-id="element-112" />
      <circle cx="89" cy="81" r="2" fill={accent} data-id="element-113" />

      <line x1="76" y1="58" x2="94" y2="64" stroke={lines} strokeWidth="1" data-id="element-114" />
      <circle cx="95" cy="64" r="1.5" fill={lines} data-id="element-115" />

      {/* Bottom */}
      <line x1="50" y1="82" x2="50" y2="96" stroke={lines} strokeWidth="1.2" data-id="element-116" />
      <circle cx="50" cy="97" r="2" fill={accent} data-id="element-117" />

      <line x1="62" y1="78" x2="72" y2="94" stroke={lines} strokeWidth="1" data-id="element-118" />
      <rect x="70.5" y="93" width="3" height="3" fill={accent} data-id="element-119" />

      <line x1="38" y1="78" x2="28" y2="94" stroke={lines} strokeWidth="1" data-id="element-120" />
      <circle cx="27" cy="95" r="1.5" fill={lines} data-id="element-121" />

      {/* Bottom-left */}
      <line x1="28" y1="68" x2="12" y2="80" stroke={lines} strokeWidth="1.2" data-id="element-122" />
      <circle cx="11" cy="81" r="2" fill={accent} data-id="element-123" />

      <line x1="24" y1="58" x2="6" y2="64" stroke={lines} strokeWidth="1" data-id="element-124" />
      <circle cx="5" cy="64" r="1.5" fill={lines} data-id="element-125" />

      {/* Left */}
      <line x1="22" y1="50" x2="4" y2="50" stroke={lines} strokeWidth="1.2" data-id="element-126" />
      <rect x="1" y="48" width="3" height="3" fill={accent} data-id="element-127" />

      {/* Top-left */}
      <line x1="28" y1="32" x2="12" y2="20" stroke={lines} strokeWidth="1.2" data-id="element-128" />
      <circle cx="11" cy="19" r="2" fill={accent} data-id="element-129" />

      <line x1="24" y1="42" x2="6" y2="36" stroke={lines} strokeWidth="1" data-id="element-130" />
      <circle cx="5" cy="36" r="1.5" fill={lines} data-id="element-131" />

      {/* Outer hexagon */}
      <polygon points="50,18 76,32 76,68 50,82 24,68 24,32" fill={secondary} opacity="0.15" stroke={secondary} strokeWidth="2" data-id="element-132" />

      {/* Middle hexagon */}
      <polygon points="50,26 68,38 68,62 50,74 32,62 32,38" fill={primary} stroke={primary} strokeWidth="2" data-id="element-133" />

      {/* Inner hexagon (cutout effect) */}
      <polygon points="50,36 60,42 60,58 50,64 40,58 40,42" fill="white" stroke={secondary} strokeWidth="1.5" data-id="element-134" />

      {/* Innermost hexagon */}
      <polygon points="50,42 55,45 55,55 50,58 45,55 45,45" fill={accent} stroke={primary} strokeWidth="1" data-id="element-135" />

      {/* Corner accents on outer hexagon */}
      <circle cx="50" cy="18" r="2.5" fill={secondary} data-id="element-136" />
      <circle cx="76" cy="32" r="2.5" fill={secondary} data-id="element-137" />
      <circle cx="76" cy="68" r="2.5" fill={secondary} data-id="element-138" />
      <circle cx="50" cy="82" r="2.5" fill={secondary} data-id="element-139" />
      <circle cx="24" cy="68" r="2.5" fill={secondary} data-id="element-140" />
      <circle cx="24" cy="32" r="2.5" fill={secondary} data-id="element-141" />
    </svg>;
}